export default {
    title  : 'iFacade.ru',
    profile : 'Профиль',
    partner : {
        title : 'Кабинет партнера. Реферальная программа iFacade.ru'
    },
    colors: ["ffdff9","ceffdc","c1e9ff","fff0d3","c0ffd3","f8d8ff","ffc8f4","d3fffa","d1cbff","ffd4d1","c2ffd9","f4d4ff","ffd3f9","dbffdc","d0d4ff","ffe2c2","feffc0","c6cdff","ffdac2","d5ffd6","d2fcff","ffeccf","e4ffcd","c3ccff","ffccdc","dbffc9","cfdaff","ffe6c2","f9ffd7","c3caff","ffddc3","d0ffd5","c5ebff","ffe9de","e4ffdd","facaff","ffc0ff","d0ffdc","dafcff","ffd5d1","d7ffc5","d4c3ff","ffd8c2","d4ffe9","c9c8ff","ffcccd","f6ffc8","f1c3ff","ffc5e1","dcffc1","c1d9ff","ffdec0","f7ffda","efdaff","ffd9cd","d8fff9","d5ffff","ffd4d6","feffda","dbc3ff","ffd2c0","c7ffe7","cfd0ff","ffc0c1","edffd5","e4c4ff","ffc6c6","d5fffb","c7f0ff","ffd6d6","d0ffdf","e5d8ff","ffdaf9","c4ffe2","d9e4ff","ffdbdf","c4ffc9","ffd6ff","ffd0c8","d3ffea","cad0ff","ffe7c4","e8ffcc","cad3ff","ffd0c6","c6ffeb","c9dbff","ffdcc1","e8ffd7","e8d6ff","ffdfda","c3ffdb","d8ffff","ffdcdd","c9ffc0","ebdbff","ffdec2","c1ffca","ced6ff","ffd1c8","c3ffc7","cdd1ff","ffddcf","cbffce","c5feff","ffe9d1","d5ffc7","c2c1ff","ffc0ec","d1ffde","c2c7ff","ffc1cf","d6ffd7","edc1ff","ffdbf4","cfffef","d3faff","ffcec2","ceffce","c3d5ff","ffd5e6","dbffe2","d5deff","ffeed0","d1ffd2","d7ddff","ffcffc","c1fff5","d0e1ff","ffd5de","e1ffc0","e6d6ff","ffcffd","d5ffe1","dcc7ff","ffc0cb","e7ffd1","d7daff","ffdfc9","d5ffd9","d8cdff","ffd1c0","ceffd1","d0ceff","ffcce7","dfffe5","c6d0ff","fffdd5","f2ffcd","c3c7ff","ffddeb","daffc4","cec7ff","ffe8d3","dcffd3","f0c7ff","ffdcf1","c9ffec","d8f5ff","fff6db","f2ffdd","fbc1ff","ffc5c9","dfffd8","c2e5ff","ffc5da","f3ffc6","f6c1ff","ffc7d2","deffd6","def7ff","ffd5dd","e1ffc0","c3c1ff","ffc4ca","d5ffe8","c9ceff","ffc1d9","d4ffcb","f8dbff","ffd6f7","c1ffe5","cff6ff","fff2c4","e2ffca","d6caff","ffc1cb","caffcc","d9edff","ffd7dd","caffce","e2deff","ffc2d9","c6fff9","c2efff","ffd4c4","e3ffc2","eed1ff","ffd5ec","dcffc6","d2f0ff","ffecda","fdffc7","dfc7ff","ffcfdc","d5ffff","ddddff","ffffd6","eeffdf","fbddff","ffd4de","deffd1","c7d1ff","ffd9c3","c6ffd4","eec5ff","ffd2e7","d7ffe7","c8f7ff","ffc3cb","e8ffd4","e0d4ff","ffc8d4","d1ffcf","d5ddff","ffe0d0","c1ffdb","dfc3ff","ffd6fa","cbffd8","d9eaff","fff5c7","c8ffc9","d4caff","ffd3e9","c1ffe0","d1c0ff","fff5c1","c3ffd9","e4c1ff","ffd9d7","d3ffed","cbc8ff","ffd4dc","dbffd0","cfc2ff","ffdae3","d7ffe3","c9e7ff","ffc3c8","e8ffd5","c6c4ff","ffcfcf","daffef","c7efff","fff1cd"],
    views : {
        tile : 'tile'
    },
    view : {
        index    : 'index',
        list     : 'list',
        item     : 'item',
        import   : 'import',
        object   : 'object',
        building : 'building',
        section  : 'section',
        control  : 'control'
    },
    page : {
        index  : 'index',
        item   : 'item',
        list   : 'list',
        form   : 'form',
        right  : {
            objects : 'objects',
            inside  : 'inside',
            outside : 'outside'
        },
        social : {
            vk   : 'vk'
        }
    },
    fields : {
        string   : 'string',
        number   : 'number',
        password : 'password',
        phone    : 'phone',
        email    : 'email',
        checkbox : 'checkbox',
        select   : 'select',
        text     : 'text',
        date     : 'date'
    },
    plan : {
        modes : {
            object   : 'object',
            building : 'building',
            floor    : 'floor'
        }
    },
    facade : {
        modes : {
            building : 'building',
            section  : 'section'
        }
    },
    document : {
        modes : {
            building : 'building'
        }
    },
    errors : {
        types : {
            validation       : 'validation',
            notFound         : 'not found',
            permissionDenied : 'permission denied',
            auth             : 'auth'
        }
    },
    widget : {
        types : {
            chess   : 'chess',
            facade  : 'facade',
            plan    : 'plan',
            catalog : 'catalog'
        }
    }
};